import React from "react";
import { RegisterOptions } from "react-hook-form";
import { NumberControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

export interface NumberValueProps {
  type: "number" | "number[]";
  prefixName: string;
  placeholder?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  validate?: RegisterOptions["validate"];
}

function NumberValue(props: NumberValueProps) {
  const {
    type,
    prefixName,
    placeholder,
    disabled,
    min,
    max = Number.MAX_SAFE_INTEGER,
    validate,
  } = props;

  const classes = useStyles();

  const name =
    type === "number[]"
      ? `${prefixName}.value.value[0]`
      : `${prefixName}.value.value`;

  return (
    <div className={classes.root}>
      <NumberControl
        name={name}
        className={classes.field}
        aria-label="Condition value"
        placeholder={placeholder}
        showHelperTextMargin
        required
        disabled={disabled}
        watchValue
        max={max}
        min={min}
        validate={validate}
      />
    </div>
  );
}

export default NumberValue;
